import { useEffect } from 'react';
import { useUserExperienceConfig } from './ConfigContext';
const CookieConsentLoader = () => {
    const getUxConfig = useUserExperienceConfig();
    useEffect(() => {
        let mounted = true;
        getUxConfig()
            .then((config) => {
            if (!mounted)
                return;
            const src = config['RBAC_UI_COOKIE_SRC'];
            const domainId = config['RBAC_UI_DATA_DOMAIN_ID'];
            if (!src || !domainId)
                return;
            const existing = document.getElementById('cookie-consent-script');
            if (existing)
                return; // already injected
            const script = document.createElement('script');
            script.id = 'cookie-consent-script';
            script.src = src;
            script.type = 'text/javascript';
            script.dataset.domainScript = domainId;
            script.async = true;
            document.head.appendChild(script);
        })
            .catch(() => {
            // Cookie consent will not load; non-critical
        });
        return () => {
            mounted = false;
        };
    }, [getUxConfig]);
    return null;
};
export default CookieConsentLoader;
